import React from "react";
import { Line } from "react-chartjs-2";
import { GraphProps } from "../../utils/types/graphProps";
/**
 *  Loads a Line Graph showing the Linear User Flow
 * 	@param {Object} props including dataset and labels
 *	@return {JSX.Element} the labels and datasets for a line graph
 */
export const UserFlowGraph = ({ labels, datasets }: GraphProps, props: any) => {
	return <Line
		data={{ labels, datasets }}
		options={{ scales: { y: { beginAtZero: true }}}}
		{...props}/>;
};

export default UserFlowGraph;